import React from "react";
import Row from "react-bootstrap/Row";
import { Camera } from "./camera";
import { camList } from "../../../app/streamData";

export function Cameras() {
  // filter out cams without streamUrl property set
  const activeCams = camList.filter((cam) => cam.streamUrl);
  const renderedList = activeCams.map((cam) => (
    <Camera key={cam.name} camera={cam} />
  ));

  return <Row>{renderedList}</Row>;
}
